import React from "react";

const unitTypeConstant = [];
unitTypeConstant[1] = "Retail";
unitTypeConstant[2] = "Office";

const unitStatusConstant = [];
unitStatusConstant[1] = "Leased";
unitStatusConstant[2] = "Non Leased";

const electricityLoadDeposit = ["Per KW", "Per KVA","Flat Amount"];

const airConditioingLoadDeposit = ["Per Tr","Flat Amount"];

const meterDeposit = ["Per Meter","Flat Amount"];

const electricityBasisUnitsGridRate = ["per KwHr","Flat Amount"];

const waterBasisUnitsBoard = ["Per KL","Flat Amount"];

const gasBasisUnitsGasBank = ["Per Cubic Meter","Flat Amount"];

const hvacBasisFlatUnitRate = ["Per Sq Ft", "Flat","Flat Amount"];

const hvacBasisBtuUnitRate = ["Rs per KwHr","Flat Amount"];

const extraHoursChargesBasisFlatRate = ["Rs. Per Hour","Flat Amount"];

const horticultureChargesFlatRate = ["Rs","Flat Amount"];

const storageFitoutDeposit = ["Flat rate", "Per Sq.ft","Flat Amount"];

const pTaxRate = [
  "Property Tax Basis Rate",
  "Property Tax Basis Pure Revenue Share",
  "Property Tax Basis Pure Revenue Share Sales Range",
  "Property Tax Basis % of Rent",
  "Property Tax Basis Vouchers",
];

const pTaxActual = ["Property Tax Basis Actual"];

const floorOptions = [
  "Basement 10 (B10)",
  "Basement 09 (B09)",
  "Basement 08 (B08)",
  "Basement 07 (B07)",
  "Basement 06 (B06)",
  "Basement 05 (B05)",
  "Basement 04 (B04)",
  "Basement 03 (B03)",
  "Basement 02 (B02)",
  "Basement 01 (B01)",
  "Lower Ground Floor (LGF)",
  "Mezzanine Floor (MZF)",
  "Upper Ground Floor (UGF)",
  "Ground Floor (GF)",
  "First Floor (01F)",
  "Second Floor (02F)",
  "Third Floor (03F)",
  "Fourth Floor (04F)",
  "Fifth Floor (05F)",
  "Sixth Floor (06F)",
  "Seventh Floor (07F)",
  "Eighth Floor (08F)",
  "Nineth Floor (09F)",
  "Tenth Floor (10F)",
  "Eleventh Floor (11F)",
  "Twelth Floor (12F)",
  "Thirteenth Floor (13F)",
  "Fourteenth Floor (14F)",
  "Fifteenth Floor (15F)",
  "Sixteenth Floor (16F)",
  "Seventeenth Floor (17F)",
  "Eighteenth Floor (18F)",
  "Nineteenth Floor (19F)",
  "Twentieth Floor (20F)",
  "Twenty First Floor (21F)",
  "Twenty Second Floor (22F)",
  "Twenty Third Floor (23F)",
  "Twenty Fourth Floor (24F)",
  "Twenty Fifth Floor (25F)",
  "Twenty Sixth Floor (26F)",
  "Twenty Seventh Floor (27F)",
  "Twenty Eighth Floor (28F)",
  "Twenty Nineth Floor (29F)",
  "Thirtieth floor (30F)",
  "Thirty First Floor (31F)",
  "Thirty Second Floor (32F)",
  "Thirty Third Floor (33F)",
  "Thirty Fourth Floor (34F)",
  "Thirty Fifth Floor (35F)",
  "Thirty Sixth Floor (36F)",
  "Thirty Seventh Floor (37F)",
  "Thirty Eighth Floor (38F)",
  "Thirty Nineth Floor (39F)",
  "Fourtieth floor (40F)",
  "Forty First Floor (41F)",
  "Forty Second Floor (42F)",
  "Forty Third Floor (43F)",
  "Forty Fourth Floor (44F)",
  "Forty Fifth Floor (45F)",
  "Forty Sixth Floor (46F)",
  "Forty Seventh Floor (47F)",
  "Forty Eighth Floor (48F)",
  "Forty Nineth Floor (49F)",
  "Fiftieth Floor (50F)",
  "Fifty First Floor (51F)",
  "Fifty Second Floor (52F)",
  "Fifty Third Floor (53F)",
  "Fifty Fourth Floor (54F)",
  "Fifty Fifth Floor (55F)",
  "Fifty Sixth Floor (56F)",
  "Fifty Seventh Floor (57F)",
  "Fifty Eighth Floor (58F)",
  "Fifty Nineth Floor (59F)",
  "Sixtieth Floor (60F)",
  "Sixty First Floor (61F)",
  "Sixty Second Floor (62F)",
  "Sixty Third Floor (63F)",
  "Sixty Fourth Floor (64F)",
  "Sixty Fifth Floor (65F)",
  "Sixty Sixth Floor (66F)",
  "Sixty Seventh Floor (67F)",
  "Sixty Eighth Floor (68F)",
  "Sixty Nineth Floor (69F)",
  "Seventieth Floor (70F)",
  "Seventy First Floor (71F)",
  "Seventy Second Floor (72F)",
  "Seventy Third Floor (73F)",
  "Seventy Fourth Floor (74F)",
  "Seventy Fifth Floor (75F)",
  "Seventy Sixth Floor (76F)",
  "Seventy Seventh Floor (77F)",
  "Seventy Eighth Floor (78F)",
  "Seventy Nineth Floor (79F)",
  "Eightieth Floor (80F)",
  "Eighty First Floor (81F)",
  "Eighty Second Floor (82F)",
  "Eighty Third Floor (83F)",
  "Eighty Fourth Floor (84F)",
  "Eighty Fifth Floor (85F)",
  "Eighty Sixth Floor (86F)",
  "Eighty Seventh Floor (87F)",
  "Eighty Eighth Floor (88F)",
  "Eighty Nineth Floor (89F)",
  "Ninetieth Floor (90F)",
  "Ninty First Floor (81F)",
  "Ninty Second Floor (82F)",
  "Ninty Third Floor (83F)",
  "Ninty Fourth Floor (84F)",
  "Ninty Fifth Floor (85F)",
  "Ninty Sixth Floor (86F)",
  "Ninty Seventh Floor (87F)",
  "Ninty Eighth Floor (88F)",
  "Ninty Nineth Floor (89F)",
  "Hundredth Floor (100F)",
];

const periodOneMileStoneNames = [
  "Due on LOI / EOI / Term Sheet",
  "Due on Agreement to Lease",
  "Due on Handover of Fitout",
  "Due on Execution of Lease Deed / License Agreement",
  "Due on Lease Commencement Date",
  "Others - Specific Date",
];

const periodOneLandlordMileStoneNames = [
  "Due on LOI / EOI / Term Sheet",
  "Due on Agreement to Lease",
  "Due on Handover Date",
  "Due on Execution of Lease Deed / License Agreement",
  "Due on Lease Commencement Date",
  "Others - Specific Date",
];
const periodOtherMilestoneNames = [
  "Escalation 1",
  "Escalation 2",
  "Escalation 3",
  "Escalation 4",
  "Escalation 5",
];

export {
  unitTypeConstant,
  unitStatusConstant,
  electricityLoadDeposit,
  airConditioingLoadDeposit,
  meterDeposit,
  electricityBasisUnitsGridRate,
  waterBasisUnitsBoard,
  gasBasisUnitsGasBank,
  hvacBasisFlatUnitRate,
  hvacBasisBtuUnitRate,
  extraHoursChargesBasisFlatRate,
  horticultureChargesFlatRate,
  floorOptions,
  periodOneMileStoneNames,
  periodOtherMilestoneNames,
  pTaxActual,
  pTaxRate,
  storageFitoutDeposit,
  periodOneLandlordMileStoneNames
};
